import axios from 'axios';

type Props = {
    accountId: string;
    eventUrl: string;
    rotaryCd: string;
}

/**
 * ユーザの参加可否を取得するAPI
 */
export async function getJoinStatus({accountId, eventUrl, rotaryCd}: Props){
    const response = await axios.get(process.env.REACT_APP_PATH + `/users/me/event/join`, {
        params: {
            rotaryCd: rotaryCd,
            accountId: accountId,
            eventUrl: eventUrl
        },
        paramsSerializer:{
            indexes: null
        }

    })
    
    return JSON.parse(JSON.stringify(response.data[0]))

}